export default (initialState, reducerObject) => (state = initialState, action) => {
    const reducerProp = reducerObject[action.type];

    return reducerProp ? reducerProp(state, action) : state;
};



// WEBPACK FOOTER //
// ./src/redux/baseReducer.js